export const baseApiUrl = '/api/core/v1';
export const baseAuthApiUrl = '/api/auth/v1';
export const basePaymentApiUrl = '/api/payment/v1';

export enum permissions {
    Admin = 'ADMIN',
    Operator = 'OPERATOR',
    PensionOperator = 'PENSION_OPERATOR',
    Dispatcher = 'DISPATCHER',
    Anonymous = 'ANONYMOUS',
    Courier = 'COURIER',
    HR = 'HR',
    Coordinator = 'COORDINATOR',
    Support = 'SUPPORT',
}

export enum Roles {
    Courier = 'COURIER',
    Cashier = 'CASHIER',
}

export enum statuses {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
    ARCHIVED = 'ARCHIVED',
    CANCELLED = 'CANCELLED',
}

export enum flightStatus {
    CREATED = 'CREATED',
    SEND = 'SEND',
    PROCESS = 'PROCESS',
    REMOVED = 'REMOVED',
}

export const photoText = new Map([
    ['TYPE_SELFIE', 'Селфи с документом'],
    ['TYPE_DOCUMENT_FRONT', 'Лицевая сторона документа'],
    ['TYPE_DOCUMENT_BACK', 'Обратная сторона документа'],
]);

export const languageMappings = new Map([
    ['ru', 'ru-RU'],
    ['en', 'en-US'],
    ['kk', 'kk-KZ'],
]);
